import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

export const PaymentCancelPage = () => {
    return (
        <div className="section-gap" data-testid="payment-cancel-page">
            <div className="container-main max-w-lg mx-auto">
                <Card className="p-8 text-center">
                    <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
                        <XCircle className="h-12 w-12 text-gray-500" />
                    </div>
                    <h1 className="font-serif text-2xl font-semibold mb-2">
                        Payment Cancelled
                    </h1>
                    <p className="text-muted-foreground mb-6">
                        Your payment was cancelled. No charges were made to your account.
                    </p>
                    <div className="flex flex-col gap-3">
                        <Button asChild className="bg-accent text-accent-foreground hover:bg-accent/90">
                            <Link to="/courses">
                                Browse Courses
                            </Link>
                        </Button>
                        <Button asChild variant="outline">
                            <Link to="/workshops">
                                View Painting Videos
                            </Link>
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default PaymentCancelPage;
